module.exports = __webpack_public_path__ + "static/media/info-24px.e24db876.svg";